import { BrowserRouter,  Route, Routes } from 'react-router-dom';
import RedirectComponent from './RedirectComponent';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='*' element={<RedirectComponent />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;